import type {
  IssuanceReportLink,
  IssuanceReportSignatureStatus,
  Policy,
} from '@/shared/api/resources';

/**
 * Apoio do laudo de emissao, do numero longo, do ramo e da versao assinada
 * (P-APO-2). Ver docs/ADR/0045-laudo-de-emissao.md.
 */

/** Permissao do laudo. Nao vale para a corretora. */
export const PERMISSAO_DO_LAUDO = 'apolices.laudo.view';

/**
 * Rotulo da versao do documento ao lado do download da apolice. Nulo e "nao
 * informado" (apolice de antes do P-APO-2): nenhum rotulo aparece.
 */
export function rotuloDaAssinatura(
  status: IssuanceReportSignatureStatus | null | undefined,
): string | null {
  if (status === 'assinada') return 'Assinada';
  if (status === 'aguardando_assinatura') return 'Aguardando assinatura';
  return null;
}

/** Ramo como o documento da apolice imprime: o codigo e o nome. */
export function ramoDaApolice(policy: Policy): string | null {
  const partes = [policy.branch_code, policy.branch_name].filter(
    (parte): parte is string => typeof parte === 'string' && parte.trim() !== '',
  );
  return partes.length > 0 ? partes.join(' - ') : null;
}

/**
 * Qual modelo montou o laudo (P-MIN-3): o da empresa, publicado em Templates, ou o
 * neutro do sistema, quando a empresa ainda nao publicou o dela. Quem baixa sabe de
 * onde saiu o leiaute; os dados sao sempre os da fotografia da emissao.
 */
export function avisoDoModeloDoLaudo(link: IssuanceReportLink): string | null {
  const modelo = link.template;
  if (!modelo) return null;
  if (modelo.source === 'empresa' && modelo.name) {
    return `Laudo montado pelo modelo "${modelo.name}", versao ${modelo.version ?? '-'}.`;
  }
  return 'Laudo montado pelo modelo neutro do sistema: a empresa ainda nao publicou um modelo de laudo de emissao em Templates.';
}

/** Por que o laudo nao esta disponivel, quando nao esta. */
export function motivoSemLaudo(policy: Policy): string | undefined {
  const laudo = policy.issuance_report;
  if (!laudo) return 'O laudo de emissao nao esta disponivel nesta instalacao.';
  return laudo.available ? undefined : laudo.reason;
}
